import { List, OrderedSet, Map } from 'immutable'
import { createSelector } from 'reselect'
import { byString, byNumber } from 'helpers/sort'

export const getValues = state => state.get('orgValues')

export const getValuesAll = createSelector(getValues, values => values.get('all'))

export const getValuesIds = createSelector(getValues, values => values.get('ids'))

export const getValuesSize = createSelector(getValuesIds, ids => ids.size)

export const getValuesView = createSelector(getValues, values => values.get('view'))

export const getValuesEditForm = createSelector(getValues, state => state.get('editForm'))

export const getValuesViewPresenter = createSelector(
  getValuesAll,
  getValuesView,
  (all, view) => (view && all.get(view)) || null
)

export const getValuesViewPresenterInitialValues = createSelector(
  getValuesViewPresenter,
  getValuesEditForm,
  (value, editForm) =>
    editForm
      ? Map(value)
          .delete('activeUsers')
          .delete('proTracksCount')
      : null
)

export const getValuesPending = createSelector(getValues, values => values.get('pending'))

export const getValuesPendingGetAll = createSelector(getValuesPending, pending => pending.get('getAll'))

export const getValuesLoaded = createSelector(getValues, values => values.get('loaded'))

export const getValuesLoadedGetAll = createSelector(getValuesLoaded, loaded => loaded.get('getAll'))

export const getValuesShowGetAllLoader = createSelector(
  getValuesSize,
  getValuesPendingGetAll,
  getValuesLoadedGetAll,
  (size, pending, loaded) => (size > 0 ? !loaded : pending)
)

export const getValuesPagination = createSelector(getValues, values => values.get('pagination'))

export const getValuesPaginationCurrent = createSelector(getValuesPagination, pagination => pagination.get('current'))

export const getValuesPaginationPerPage = createSelector(getValuesPagination, pagination => pagination.get('perPage'))

export const getValuesPageCount = createSelector(getValuesIds, getValuesPaginationPerPage, (ids, perPage) =>
  Math.ceil(ids.size / perPage)
)

export const getValuesSort = createSelector(getValues, values => values.get('sort'))

export const getValuesSortBy = createSelector(getValuesSort, sort => sort.get('by'))

export const getValuesSortDesc = createSelector(getValuesSort, sort => sort.get('desc'))

export const getValuesSortedIds = createSelector(
  getValuesAll,
  getValuesIds,
  getValuesSortBy,
  getValuesSortDesc,
  (all, ids, by, desc) => {
    if (!by) {
      return ids
    }
    return OrderedSet(
      all
        .sortBy(
          value => value.get(by),
          (a, b) => {
            switch (by) {
              case 'name':
                return byString(a, b, desc)
              case 'proTracksCount':
                return byNumber(a, b, desc)
              case 'activeUsers':
                return byNumber(a, b, desc)
            }
            return 0
          }
        )
        .keySeq()
    )
  }
)

export const getValuesSortedIdsSliced = createSelector(
  getValuesSortedIds,
  getValuesPaginationCurrent,
  getValuesPaginationPerPage,
  (ids, currentPage, perPage) => ids.skip(currentPage * perPage).take(perPage)
)

export const getValuesList = createSelector(getValuesAll, getValuesSortedIdsSliced, (all, ids) =>
  List(ids.map(id => all.get(id.toString())))
)
